<template>
    <q-page class="q-pa-md">
        <duplicate-checks ref="duplicateChecks"></duplicate-checks>
    </q-page>
</template>

<script>
    export { default } from './duplicatecheckapplicationviewmodel-custom-screen.js'
</script>